/** A read-back before committing: label/value rows and a total. */
import { z } from 'zod';
import { defineWidget } from '../contract';
import { Icon } from '../../ui-kit/Icon';
import { Panel } from '../../ui-kit/Panel';
import css from '../Widgets.module.css';

const schema = z.object({
  title: z.string(),
  subtitle: z.string().optional(),
  icon: z.string().optional(),
  rows: z.array(z.object({ label: z.string(), value: z.string(), icon: z.string().optional() })),
  total: z.object({ label: z.string(), value: z.string() }).optional(),
  note: z.string().optional(),
});

export const summary = defineWidget({
  key: 'summary',
  schema,
  Component: ({ props }) => (
    <Panel title={props.title} subtitle={props.subtitle} icon={props.icon}>
      <dl className={css.rows}>
        {props.rows.map((r) => (
          <div key={r.label} className={css.rowItem}>
            <dt>{r.icon && <Icon name={r.icon} size={28} />}{r.label}</dt>
            <dd>{r.value}</dd>
          </div>
        ))}
      </dl>
      {props.total && (
        <div className={css.total}>
          <span>{props.total.label}</span>
          <strong>{props.total.value}</strong>
        </div>
      )}
      {props.note && <p className={css.footer}>{props.note}</p>}
    </Panel>
  ),
});
